const NearingLateClockoutBanner = () => {
	return (
		<div className="p-8 font-bold text-center warning-banner-pulse z-50 w-full">
			<p>You are nearing 6 hours of work time. Please clock out or take a lunch before 6 hours.</p>
		</div>
	);
};

export default NearingLateClockoutBanner;
